<template>
    <div class="main-container">
        <div></div>
        <nav class="bck-second-d text-third" style="height: 65px;">
            <div class="p-x-5" style="height: 65px;">
                <div class="row-12" style="height: 65px;">
                    <div class="col">
                        <div class="burger">
                            <div class="burger-icon"></div>
                        </div>
                        <div class="nav-logo center-flex-a">
                            <router-link to="/" class="center-flex-a"><img style="width: 140px;"
                                                                           :src="logoImg"
                                                                           alt="conspect animator"></router-link>
                        </div>
                        <ul class="left-nav-menu">
                            <li>
                                <router-link to="/">Strona główna</router-link>
                            </li>
                            <li>
                                <div class="nav-drop-header">Projekty</div>
                                <ul>
                                    <li class="nav-drop-name">Projekty</li>
                                    <li>
                                        <router-link to="/createanimation">Stwórz nowy projekt</router-link>
                                    </li>
                                    <li>
                                        <router-link to="/practice">Przeglądaj projekty</router-link>
                                    </li>
                                    <li>
                                        <router-link to="/sharedPractice">Udostępnione dla mnie</router-link>
                                    </li>
                                </ul>
                            </li>
                            <li>
                                <div class="nav-drop-header">Konspekty</div>
                                <ul>
                                    <li class="nav-drop-name">Konspekty</li>
                                    <li>
                                        <router-link to="/createConspect">Zbuduj nowy konspekt</router-link>
                                    </li>
                                    <li>
                                        <router-link to="/conspect-list">Przeglądaj konspekty</router-link>
                                    </li>
                                    <li>
                                        <router-link to="/sharedConspect">Udostępnione dla mnie</router-link>
                                    </li>
                                </ul>
                            </li>
                        </ul>
                        <ul class="additional-menu">
                            <li>
                                <a href="" @click.stop.prevent="openChat()" class="center-flex-a">
                                    <i class="text-third-l i-envelope i-md"></i>
                                    <span class="count" v-if="allNotReadCounter>0">{{allNotReadCounter}}</span>
                                </a>
                            </li>
                            <li>
                                <router-link to="/calendar" class="center-flex-a"><i
                                        class="text-third-l i-calendar i-md"></i>
                                </router-link>
                            </li>
                            <li><a href="" @click.prevent="notificationOpen()" class="center-flex-a"><i
                                    class="text-third-l i-bell i-md"></i><span class="count" v-if="notificationCount>0">{{notificationCount}}</span></a>
                            </li>
                        </ul>
                        <ul class="right-nav-menu">
                            <li>
                                <div class="nav-drop-header center-flex-a" style="min-height: 65px;"><i
                                        class="text-third-l i-user i-md"></i></div>
                                <ul>
                                    <li class="nav-drop-name">{{currentUser}}</li>
                                    <li>
                                        <router-link to="/profile">Mój profil</router-link>
                                    </li>
                                    <li>
                                        <router-link to="/friends">Moi znajomi</router-link>
                                    </li>
                                    <li><a href="#" @click="logout()">Wyloguj</a></li>
                                </ul>
                            </li>
                        </ul>
                        <div class="right-burger">
                            <div class="settings-icon">
                                <i class="i-settings i-lg"></i>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </nav>
        <main class="p-x-5">
            <router-view></router-view>
        </main>
        <footer>
            <div class="row-12">
                <div class="col-4 col-sm-12"></div>
                <div class="col-4 col-sm-12">
                    <div class="copyright">All rights reeserved</div>
                </div>
                <div class="col-4 col-sm-12"></div>
            </div>
        </footer>
        <div id="notificationsmodal" class="modal">
            <notivication-view></notivication-view>
        </div>
        <chat-modal></chat-modal>
    </div>
</template>

<script>
    import NotificationView from './Notifications/NotificationsView'
    import ChatModal from '../components/ChatModal'
    import logoImg from '../assets/logoImg.svg'

    export default {
        components: {
            'notivication-view': NotificationView,
            'chat-modal': ChatModal
        },
        data: () => {
            return {
                logoImg: logoImg,
            };
        },
        methods: {
            async openChat(){
                if(this.$store.state.chat.actualOpened){
                    await Chat.openChat(this.$store.state.chat.actualOpened,async ()=>{
                        this.$store.commit("initChat", await window.Chat.getChatCounterList());
                        this.showModal('#chat-modal');
                    });
                }else{
                    this.$store.commit("initChat", await window.Chat.getChatCounterList());
                    this.showModal('#chat-modal');
                }

                if (this.$store.state.chat.counteredList.length <= 0) {
                    $('.nofriendsmodal-shadow').css('display', 'block');
                    this.showModal('#nofriendsmodal');
                }
            },
            logout() {
                AuthMiddleware.logout();
                this.$router.push('/login');
            },
            checkNotifications(number, random) {
                let numberOfNotifications = this.notificationsList.length;
                let tmp = numberOfNotifications;
                this.notificationsList.push({
                    id: tmp += 1,
                    date: random.date[number],
                    description: random.description[number]
                });

                if (numberOfNotifications < tmp) {
                    this.storedAwaitingNotifications = tmp - this.storedReadNotifications;
                }
            },
            notificationOpen() {
                this.showModal('#notificationsmodal');
                localStorage.setItem("isOpenedNotifications",true);
            },
            chatOpen() {

            }
        },
        mounted: function () {
            this.$store.dispatch('asyncGetNotifications');
            this.$store.dispatch('initChatSocket');
            if ($(document).width() <= 990) {
                $('.right-nav-menu .nav-drop-header').addClass('activedHeaderDropdown');
                $('.right-nav-menu ul').addClass('activedDropdown');
            }
            localStorage.setItem("isOpenedNotifications",false);
        },
        computed: {
            currentUser: function () {
                if (AuthMiddleware.user && AuthMiddleware.user.firstname) {
                    return AuthMiddleware.user.firstname + ' ' + AuthMiddleware.user.lastname;
                }
                return '';
            },
            allNotReadCounter: function () {
                return this.$store.state.chat.allNotReadCounter;
            },
            notificationCount: function () {
                return this.$store.state.notifications.newCount;
            }
        }
    }
</script>

<style lang="scss">
    .settings-icon {
        display: flex;
    }

    .additional-menu {
        position: absolute;
        right: 75px;
        @media(max-width: 992px) {
            left: 50%;
            transform: translateX(-50%);
            right: auto;
        }
    }

    .nav-logo {
        @media(max-width: 992px) {
            display: none;
        }
    }

    footer > div {
        height: 100%;
    }

    .copyright {
        width: 100%;
        height: 100%;
        align-items: center;
        display: flex;
        line-height: .75em !important;
        justify-content: center;
        font-size: .75em;
        text-align: center;
        color: #fbfbfb;
    }

    .count {
        position: absolute;
        top: 17px;
        height: 15px;
        width: 15px;
        overflow: hidden;
        background: #1dc8ff;
        color: #fff;
        text-align: center;
        border-radius: 100%;
        font-size: 9px;
        font-weight: bold;
        line-height: 16px;
        display: inline-block;
        margin-left: 8px;
        vertical-align: middle;
    }
</style>
